namespace GeniuzPOS.AdvPromo {
@Serenity.Decorators.registerClass()
export class Adv05ItemExDTsEditor extends Serenity.Extensions.GridEditorBase<Adv05ItemExDTsRow> {
    protected getColumnsKey() { return Adv05ItemExDTsColumns.columnsKey; }
    protected getDialogType() { return Adv05ItemExDTsDialog; }
    protected getLocalTextPrefix() { return Adv05ItemExDTsRow.localTextPrefix; }
    protected getService() { return Adv05ItemExDTsService.baseUrl; }


    constructor(container: JQuery) {
        super(container);
    }
    protected getButtons() {
        var buttons = super.getButtons();

        // remove first button (Add button)
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

        // Add buttons import excel, pdf      
        
       
        return buttons;
    }



    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected getViewOptions() {
        var opt = super.getViewOptions();
        opt.localSort = true;
        return opt;
    }

   

    
}}